import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

import BannerBackground from '../../../assets/img/heroBannerParticles.svg'
import WaveBackground from '../../../assets/img/zing-rewards.webp'
import media from '../../../services/generateMediaQueries'
import PromoMobileBG from '../../../assets/img/promo-banner-mobile.jpg'

export const BannerRewardsImage = styled.div`
  background-repeat: no-repeat;
  background-position: center bottom -1px;
  background-size: 48rem;
  background-image: url(${WaveBackground});
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  ${media.greaterThan('small')`
    background-size: contain;
  `}
`

export const BannerWrapper = styled.div`
  position: relative;
  color: #fff;
  top: 0;
  padding-bottom: 29rem;
  margin-bottom: -29rem;
  ${media.greaterThan('medium')`
    padding-bottom: 2rem;
    margin-bottom: 0;
  `}

  ${props =>
    props.variant === 'rewards' &&
    css`
      padding-bottom: 2rem;
      margin-bottom: 0;
    `}

  ${props =>
    props.variant === 'explore' &&
    css`
      padding-bottom: 33rem;
    `}
`

export const Banner = styled.div`
  position: absolute;
  width: 100%;
  transition-property: height;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);
`

export const BannerTopGradient = styled.div`
  position: absolute;
  width: 100%;
  transition-property: height;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);
  height: 300px;
`

export const BannerBottomGradient = styled(Banner)`
  ${media.lessThan('medium')`
    height: ${props => {
      const padding = props.variant === 'explore' ? 200 : 0

      return props.featuredDisplayed
        ? `${1600 + padding}px`
        : `${1025 + padding}px`
    }};
  `}
  ${props =>
    props.variant === 'rewards' &&
    css`
      height: 600px;

      ${media.lessThan('medium')`
        height: 800px;
      `}
    `}
`

export const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex: 1 0 auto;
  margin: 0 auto;
  width: 100%;
  padding-top: 3.75rem;
  ${media.greaterThan('medium')`
    padding-top: 5rem;
  `}
`

export const ContentContainer = styled.div`
  margin: 0 ${({ heroBannerLeft }) => (heroBannerLeft ? '5vw' : 'auto')};
  display: flex;
  align-items: center;
  ${({ heroBannerLeft }) => !heroBannerLeft && 'justify-content: flex-end;'}
  max-width: 1024px;
 min-height: 600px;
  width: 100%;

  ${props =>
    props.variant === 'rewards' &&
    css`
      max-width: 512px;
      height: 75vw;
      padding-bottom: 25vw;
      ${media.greaterThan('small')`
      height: 50vw;
    `}
    `}

  ${media.greaterThan('small')`
    width: auto;
    margin: 0 ${({ heroBannerLeft }) => (heroBannerLeft ? '8vw' : 'auto')};
  `}

  ${media.lessThan('small')`
     min-height: ${({ variant }) => {
       switch (variant) {
         case 'main':
           return '0px'
         case 'promos-events':
           return '250px'
         default:
           return '600px'
       }
     }};
    `}
`

export const ContentArea = styled.div`
  padding: 0 1rem;
  width: 100%;

  ${props =>
    props.variant === 'watch' &&
    css`
      ${media.greaterThan('small')`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      `}
    `}

  ${props =>
    props.variant === 'rewards' &&
    css`
      text-align: center;
      ${media.greaterThan('small')`
    `}
    `}

  ${props =>
    props.hasSelectedMall &&
    css`
      ${media.greaterThan('small')`
          display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      `}
    `}

  ${props =>
    props.variant !== 'watch' &&
    props.variant !== 'rewards' &&
    !props.hasSelectedMall &&
    css`
      ${media.greaterThan('small')`
      width: 50%;
    `}
    `}
`

export const TitleContainer = styled.div`
  width: 100%;
  margin-bottom: 3rem;
  ${media.greaterThan('small')`
    margin-bottom: 0;
  `}
`

export const Title = styled.h1`
  font-size: 4rem;
  font-weight: var(--font-weight-boldest);
  line-height: 4rem;
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 0;

  ${media.lessThan('medium')`
    font-size: 2.8125rem;
    letter-spacing: 0;
    line-height: 2.375rem;
    margin-bottom: 1.5rem;
  `}

  ${media.lessThan('small')`
    margin-bottom: 1.5rem;
    font-size: 2.25rem;
    letter-spacing: 0;
    line-height: 1.875rem;
  `}
`

export const SubtitleContainer = styled.div`
  width: 100%;
  text-align: center;
  ${media.greaterThan('small')`
    text-align: left;
  `}
`

export const Subtitle = styled.p`
  font-size: 1.5rem;
  line-height: 1.5;
  letter-spacing: var(--letter-spacing-wider);
  font-weight: var(--font-weight-bold);
  margin: 0;
  text-align: ${props => (props.variant === 'rewards' ? 'center' : 'left')};

  ${media.lessThan('medium')`
    font-size: 1.125rem;
    letter-spacing: 0.5px;
    margin-bottom: 3rem;
    text-align:  center;
  `}

  ${media.lessThan('small')`
    letter-spacing: 0.5px;
    margin-bottom: 2.375rem;
    margin-left: 0;
    padding: 0;
  `}
`

export const SelectMallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3.3125rem;
  gap: 1rem;

  ${media.lessThan('medium')`
  margin-bottom: 3.3125rem;
  `}
`

export const SelectMallButton = styled.button`
  display: flex;
  width: 100%;
  flex: 0 0 auto;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  background: transparent;
  height: 3rem;
  border: 1px solid #ffffff;
  border-radius: 4px;
  padding: 0 1rem;

  &:focus {
    outline-color: transparent;
  }
`
export const ViewButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
`
export const ViewMallMap = styled.button`
  flex: 1;
  font-size: 0.75rem;
  font-weight: var(--font-weight-boldest);
  height: 3rem;
  padding: 0 1.25rem;
  border-radius: var(--border-radius-form);
  color: ${props => (props.disabled ? '#ffffff' : 'var(--color-secondary)')};
  background: ${props =>
    props.disabled ? 'rgba(255, 255, 255, 0.3)' : '#ffffff'};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  border: none;
`
export const ViewMallDirectory = styled.button`
  flex: 1;
  font-size: 0.75rem;
  font-weight: var(--font-weight-boldest);
  height: 3rem;
  padding: 0 1.25rem;
  border-radius: var(--border-radius-form);
  color: ${props => (props.disabled ? '#ffffff' : '#fff')};
  background: ${props =>
    props.disabled ? 'rgba(255, 255, 255, 0.3)' : '#db6b30'};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  border: none;
`

export const DropdownError = styled.p`
  margin: 0;
  margin-top: 30px;
  font-size: 13px;
  color: red;
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  border: 1px solid;
  color: inherit !important;
  border-radius: 5px;
  border-color: #db6b30;
  background-color: #db6b30;

  padding: 0.5rem;
  margin: 0.1rem 0 0 0;
  display: inline-block;
  line-height: 1;
  font-size: 0.65em;
  vertical-align: middle;
`

export const FeaturedSectionWrapper = styled.div`
  position: relative;
  padding: 0 1rem;
  box-sizing: border-box;
`

export const BannerImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  mask-image: linear-gradient(#fff 0%, #fff 60%, #fff0 100%);
  background-color: #429090;

  ${({ $variant }) =>
    ['explore', 'rewards'].includes($variant)
      ? css`
          height: 100%;
        `
      : css`
          height: 70%;
        `}

  ${media.lessThan('small')`
    height: 100%;
  `}
`

export const PromosBannerOverlayTop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  pointer-events: none;
`

export const PromosBannerOverlayRight = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 70%;
  max-width: 720px;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.55) 0%,
    rgba(0, 0, 0, 0.35) 50%,
    transparent 100%
  );
  pointer-events: none;
`

export const BannerImage = styled.div`
  width: 100%;
  background-size: cover;
  background-position: center;
  mask-image: linear-gradient(#fff 0%, #fff 90%, #fff0 100%);
  -webkit-mask-image: linear-gradient(#fff 0%, #fff 90%, #fff0 100%);

  background-image: ${({ $bgUrl }) => ($bgUrl ? `url(${$bgUrl})` : 'none')};

  ${media.lessThan('small')`
    background-position: left center;
  `}

  ${({ $variant }) =>
    $variant === 'promos-events' &&
    media.lessThan('small')`
      aspect-ratio: 390 / 844;
      height: auto !important;
      width: 100%;
      background-image: url(${PromoMobileBG});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      mask-image: none;
      -webkit-mask-image: none;
    `}
`

export const BannerVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  mask-image: linear-gradient(#fff 0%, #fff 90%, #fff0 100%);
  -webkit-mask-image: linear-gradient(#fff 0%, #fff 90%, #fff0 100%);
  transform: translateZ(0);
  backface-visibility: hidden;
`

export const BannerParticles = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  /* background: repeat-y top / auto 100% url('${BannerBackground}'); */
`
